"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickbooksSetting_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var QuickbooksSetting_Factory = /** @class */ (function () {
    function QuickbooksSetting_Factory() {
    }
    QuickbooksSetting_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SettingCode: model.SettingCode,
            SettingValue: model.SettingValue,
        };
        return result;
    };
    QuickbooksSetting_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SettingCode: model.SettingCode,
            SettingValue: model.SettingValue,
        };
        return result;
    };
    return QuickbooksSetting_Factory;
}());
exports.QuickbooksSetting_Factory = QuickbooksSetting_Factory;
